import CustomLink from 'components/Globals/Base/Link';
import * as S from 'components/Company/EarningsReportsList/EarningsReportsListStyles';
import PoweredByQuartr from 'components/Company/EarningsReportsList/PoweredByQuartr';
import NextArrow from 'components/Arrows/NextArrow';

export interface EarningsList {
  title: string;
  slug: string;
}

export interface EarningsReportsListProps {
  reports: EarningsList[];
}

const EarningsReportsList = ({ reports }: EarningsReportsListProps) => (
  <S.Container>
    <PoweredByQuartr />
    <S.List>
      {reports.map((report) => (
        <S.ListItem key={report.slug}>
          <CustomLink href={`./earnings/${report.slug}/`}>
            {report.title} <NextArrow className='next-arrow' />
          </CustomLink>
        </S.ListItem>
      ))}
    </S.List>
  </S.Container>
);

export default EarningsReportsList;
